<template>
  <div v-if="visible" class="ia4-overlay" @click.self="$emit('close')">
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="ia4com-info-title"
      class="ia4-modal">
      <div class="ia4-content">
        <div class="ia4-top">
          <div class="ia4-icon">
            <img :src="icons.ia4com" alt="">
          </div>
          <button type="button" class="ia4-close" aria-label="Fechar" @click="$emit('close')">
            <img :src="icons.close" alt="" width="20" height="20">
          </button>
        </div>
        <div class="ia4-heading">
          <p id="ia4com-info-title" class="ia4-title">IA4COM</p>
          <p class="ia4-subtitle">O assistente de vendas que ajuda a vender mais.</p>
        </div>
        <div class="ia4-divider"></div>
        <div class="ia4-section">
          <p class="ia4-section-title">O que ele faz</p>
          <ul class="ia4-list">
            <li v-for="item in items" :key="item">
              <img :src="icons.check" alt="" width="18" height="18">
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="ia4-actions" :class="{ 'ia4-actions--end': !infoUrl }">
        <a
          v-if="infoUrl"
          :href="infoUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="ia4-more">
          Conheça o IA4COM
          <img :src="icons.arrow" alt="" width="20" height="20">
        </a>
        <button type="button" class="ia4-ok" @click="$emit('close')">Entendi</button>
      </div>
    </div>
  </div>
</template>

<script>
import ia4comIcon from '@/assets/images/plans/ia4com-icon.svg'
import closeIcon from '@/assets/images/plans/x-close.svg'
import checkIcon from '@/assets/images/plans/check-muted.svg'
import arrowIcon from '@/assets/images/plans/arrow-up-right-link.svg'

// Texto fixo do Figma: o modal explica o produto, sem preço.
const IA4COM_ITEMS = [
  'Analisa a ligação e indica o próximo passo',
  'Escreve o follow-up: e-mail, WhatsApp e CRM',
  'Responde com o método SPIN Selling',
  'Conhece seu mercado, ticket e ciclo de vendas'
]

export default {
  name: 'Ia4comInfoModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // Vazio esconde o link (ainda sem endereço; vem de variável de ambiente)
    infoUrl: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      items: IA4COM_ITEMS,
      icons: { ia4com: ia4comIcon, close: closeIcon, check: checkIcon, arrow: arrowIcon }
    }
  },
  watch: {
    visible (isVisible) {
      if (isVisible) document.addEventListener('keydown', this.closeOnEscape)
      else document.removeEventListener('keydown', this.closeOnEscape)
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.closeOnEscape)
  },
  methods: {
    closeOnEscape (event) {
      if (event.key === 'Escape') this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.ia4-overlay {
  position: fixed;
  top: 0; right: 0; bottom: 0; left: 0;
  z-index: 1050;
  display: flex; align-items: center; justify-content: center;
  padding: 16px;
  background: rgba(15, 23, 43, 0.6);
}
.ia4-modal {
  width: 100%;
  max-width: 444px;
  overflow: hidden;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 12px 16px -4px rgba(16, 24, 40, 0.08), 0 4px 6px -2px rgba(16, 24, 40, 0.03);
  font-family: 'Inter', ui-sans-serif, system-ui, sans-serif;

  p { margin: 0; }
}
.ia4-content { display: flex; flex-direction: column; gap: 16px; padding: 24px; }
.ia4-top { display: flex; align-items: center; justify-content: space-between; }
// O SVG do Figma traz a sombra do ícone e é maior que a caixa de 48px: as margens
// negativas são as do design, para o quadrado cair exatamente na caixa.
.ia4-icon {
  position: relative;
  width: 48px; height: 48px;
  flex-shrink: 0;
  img {
    position: absolute;
    top: -54.17%; right: -83.34%; bottom: -112.51%; left: -83.34%;
    width: 266.68%; height: 266.68%;
    max-width: none;
    display: block;
  }
}
.ia4-close {
  display: flex; align-items: center; justify-content: center;
  width: 36px; height: 36px;
  padding: 8px;
  border: none; border-radius: 8px;
  background: transparent;
  cursor: pointer;
  &:hover { background: #f1f5f9; }
  img { display: block; }
}
.ia4-heading { display: flex; flex-direction: column; gap: 2px; }
.ia4-title { color: #0f172b; font-size: 18px; line-height: 28px; font-weight: 700; letter-spacing: -0.18px; }
.ia4-subtitle { color: #45556c; font-size: 14px; line-height: 20px; }
.ia4-divider { height: 1px; background: #e2e8f0; }
.ia4-section { display: flex; flex-direction: column; gap: 6px; }
.ia4-section-title { color: #0f172b; font-size: 14px; line-height: 20px; font-weight: 600; }
.ia4-list {
  display: flex; flex-direction: column; gap: 4px;
  margin: 0; padding: 0; list-style: none;
  li { display: flex; align-items: center; gap: 10px; color: #45556c; font-size: 14px; line-height: 20px; }
  img { display: block; flex-shrink: 0; }
}
.ia4-actions {
  display: flex; align-items: center; justify-content: space-between;
  padding: 20px 24px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  &--end { justify-content: flex-end; }
}
.ia4-more {
  display: inline-flex; align-items: center; gap: 6px;
  color: #1488d6;
  font-size: 14px; line-height: 20px; font-weight: 600;
  text-decoration: underline;
  img { display: block; flex-shrink: 0; }
}
.ia4-ok {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #0f172b;
  font-family: inherit; font-size: 14px; line-height: 20px; font-weight: 600;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
  cursor: pointer;
  &:hover { background: #f8fafc; }
}
</style>



// WEBPACK FOOTER //
// src/components/Subscription/Ia4comInfoModal.vue